import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=beb4047c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=beb4047c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb4047c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb4047c')) {
      api.createRecord('beb4047c', component.options)
    } else {
      api.reload('beb4047c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=beb4047c&scoped=true&", function () {
      api.rerender('beb4047c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8gORnCsGu15Rv/JS/comp/PopupBox.vue"
export default component.exports